import { useMemo } from "react";
import { CommandDialog, CommandEmpty, CommandGroup, CommandInput, CommandItem, CommandList } from "@/components/ui/command";
import { useTools } from "@/lib/useTools";
import { getToolIcon } from "@/lib/toolIcons";

export function CommandPalette({ open, onOpenChange, onSelect }) {
  const { tools } = useTools();

  const groups = useMemo(() => {
    const g = {};
    tools.forEach((t) => {
      (g[t.category] = g[t.category] || []).push(t);
    });
    return g;
  }, [tools]);

  return (
    <CommandDialog open={open} onOpenChange={onOpenChange}>
      <CommandInput data-testid="cmd-palette-input" placeholder="Search 200+ tools…" />
      <CommandList>
        <CommandEmpty>No tools found.</CommandEmpty>
        {Object.entries(groups).map(([cat, arr]) => (
          <CommandGroup key={cat} heading={cat.toUpperCase()}>
            {arr.map((t) => {
              const Icon = getToolIcon(t.id, t.category);
              return (
                <CommandItem
                  key={t.id}
                  value={`${t.name} ${t.desc} ${t.category}`}
                  onSelect={() => onSelect(t.id)}
                  data-testid={`cmd-item-${t.id}`}
                >
                  <Icon className="mr-2 h-4 w-4" />
                  <span className="font-medium">{t.name}</span>
                  <span className="ml-2 text-xs text-muted-foreground">{t.desc}</span>
                  {!t.functional && <span className="ml-auto text-[10px] font-mono uppercase tracking-widest text-muted-foreground">Soon</span>}
                </CommandItem>
              );
            })}
          </CommandGroup>
        ))}
      </CommandList>
    </CommandDialog>
  );
}
